

















































import Preloader from '@/components/other/Preloader'
import CompilationHeaderImg from "@/components/compilations/CompilationHeaderImg"
import ItemList from "@/components/gallery/ItemList"
import Pagination from "@/components/other/Pagination"
import MtArrowLink from '@/components/other/MtArrowLink'
import Sponsors from "@/components/compilations/Sponsors"
import CompilationDescription from "@/components/compilations/CompilationDescription"
import LinkedCompSection from "@/components/compilations/LinkedCompSection"
import ShareBlock from "@/components/compilations/ShareBlock"
import {getContentByCode} from "@/utils/utils";

export default {
  components: {
    CompilationHeaderImg,
    MtArrowLink,
    ItemList,
    Pagination,
    Sponsors,
    CompilationDescription,
    Preloader,
    LinkedCompSection,
    ShareBlock
  },
  data () {
    return {
      loadedPage: false,
      loadingGallery: true
    }
  },
  computed: {
    currentPage () {
      return this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1
    },
    compilation () {
      if (this.getCompilation?.data?.data.hasOwnProperty('id')) {
        return this.getCompilation.data.data
      } else {
        return false
      }
    }
  },
  watch: {
    getGallery () {
      this.loadingGallery = true
      if(!this.getGallery?.data?.data?.length){
        this.loadingGallery = false
      }
    }
  },
  methods: {
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    }
  },
  head() {
    return {
      title: this.compilation?.seo?.title,
      meta: [
        { hid: 'title', property: 'title', content: this.compilation?.seo?.title },
        { hid: 'og:title', property: 'og:title', content: this.compilation?.seo?.title },
        { hid: 'description', property: 'description', content: this.compilation?.seo?.description },
        { hid: 'og:description', property: 'og:description', content: this.compilation?.seo?.description },
        { hid: 'og:image-url', property: 'og:image:url', content: this.compilation?.seo?.image },
        { hid: 'og:image', property: 'og:image', content: this.compilation?.seo?.image }
      ]
    }
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'comp-detail-texts',
        auto: true,
        params: {
          code: ['podborki-see-all'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getCompilation () {
      const compilationId = this.$route.params.code
      return {
        url: `/api/compilation/`,
        key: `compilation-item`,
        params: {
          lang: this.$i18n.locale || 'ru',
          id: compilationId
        },
        on: {
          success () {
            if (!this.getCompilation?.data?.data.hasOwnProperty('id')) {
              this.$nuxt.error({ statusCode: 404 })
            }
          }
        }
      }
    },
    getGallery () {
      const compilationId = this.$route.params.code
      let config = {}
      config = {
        pageNum: this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1,
        pageSize: this.$route.query.canPatron ? 20 : 18,
        id: compilationId,
        lang: this.$i18n.locale || 'ru'
      }
      return {
        url: `/api/masterpieces/`,
        key: `compilation-list-${config.pageNum}`,
        params: {
          ...config,
        },
        on: {
          success() {
            if (this.loadedPage) {
              if (typeof window !== 'undefined') {
                const anchor = document.querySelector('#galleryStart')
                if (anchor) {
                  window.scrollTo(0, anchor.offsetTop - 100);
                }
              }
            }
            if (!this.loadedPage) {
              this.loadedPage = true
            }
            const bodyEl = document.querySelector('body')
            bodyEl.style.overflow = 'visible'
          }
        }

      }
    }
  }
}
